/**
 * CalcIcon — глиф калькулятора тарифа (по макету: карточка со строками).
 * Общий для калькуляторов десктопа и мобилки.
 */

type CalcIconProps = {size?: number};

export const CalcIcon = ({size = 16}: CalcIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
  >
    <rect x="4" y="2.5" width="16" height="19" rx="2.5" />
    <path d="M8 7h8M8 11h8M8 15h4" />
  </svg>
);
